export const convertToInches = val => {
  const mmToInch = Number(val) / 25.4
  // 1/32" conversion
  return parseInt(mmToInch * 32, 10) / 32
}

export const convertToMm = val => {
  return Math.round(val * 25.4)
}
